/* eslint-disable camelcase */
<template>
  <div>
    <h4 class="card_titulos font-bold">Informações Pessoais</h4>
    <ul class="text-gray700 list_container_ul">
      <li class="flex list_items_ul">
        <span class="font-bold span_type">Nome:</span>
        <span class="text-gray700">{{ estudante.nome }}</span>
      </li>
      <li class="flex list_items_ul">
        <span class="font-bold span_type">B.I:</span>
        <span class="text-gray700">{{ estudante.bi }}</span>
      </li>
      <li class="flex list_items_ul">
        <span class="font-bold span_type">Matrícula:</span>
        <span class="text-gray700">{{ estudante.numero_matricula }}</span>
      </li>
      <li class="flex list_items_ul">
        <span class="font-bold span_type">Curso:</span>
        <span class="text-gray700">{{ estudante.descricao }}</span>
      </li>
      <li class="flex list_items_ul">
        <span class="font-bold span_type">Telefone:</span>
        <span class="text-gray700">{{ estudante.telefone }}</span>
      </li>
      <li class="flex list_items_ul">
        <span class="font-bold span_type">Classe:</span>
        <span class="text-gray700">{{
          getClasse(estudante.classe_descricao)
        }}</span>
      </li>
      <li class="flex list_items_ul">
        <span class="font-bold span_type">Turma:</span>
        <span class="text-gray700">{{
          estudante.turma
        }}</span>
      </li>
      <li class="flex list_items_ul">
        <span class="font-bold span_type">Email:</span>
        <span class="text-gray700">{{
          estudante.email
        }}</span>
      </li>
      <li class="flex list_items_ul">
        <span class="font-bold span_type">Bolseiro:</span>
        <span class="text-gray700">{{
          EstudanteBolseiro.length
            ? 'Sim' +
            "-" +
            EstudanteBolseiro[0].ongBolsa
            : "Não"
        }}</span>
      </li>
      <li class="flex list_items_ul">
        <span class="font-bold span_type">Saldo:</span>
        <span class="text-gray700">{{
          utilitarios.IntegerToMoneyValueFatura(saldoEstudante)
        }}</span>
      </li>
    </ul>
    <v-list>
      <v-list-item @click="editarDados()" v-if="showEditarContainer">
        <v-icon color="blue">edit</v-icon> Editar Dados
      </v-list-item>

      <v-list-item @click="imprimirFichaConfirmacao()">
        <v-icon color="red">print</v-icon> Imprimir Ficha
      </v-list-item>
    </v-list>
  </div>
</template>
My CRUD
<script>
import Swal from "sweetalert2";
import axios from "../../plugins/axios";
import utilitarios from "../../plugins/utilitarios";
import impressaoService from "../../services/impressaoService";
const ls = require("local-storage");
export default {
  name: "informacoesPessoais",
  props: ["estudante"],
  data: () => ({
    utilitarios: utilitarios,
    showEditarContainer: false,
    config: null,
    templateFull: null,
    EstudanteBolseiro: [],
    saldoEstudante: 0
  }),

  computed: {
    idInstituicao() {
      return ls.get("i_id");
    }
  },

  created() {
    this.config = ls.get("configuracaoinstituicao");
    this.vericarBolseiro();
    this.pesquisarStatusSaldo();
    this.getTemplateRelatorio();
    this.verificarPermissaoEditarEst();
  },

  methods: {
    async vericarBolseiro() {
      try {
        this.EstudanteBolseiro = await axios
          .get("/vericarStatusBolseiro/" + this.estudante.numero_matricula)
          .then((res) => res.data);
      } catch (error) {
        Swal.fire(
          "Erro",
          "Ocorreu um erro durante a verificação de bolsa!",
          "error"
        );
      }
    },

    async verificarPermissaoEditarEst() {
      try {
        let status = await axios
          .get(`/verificarHabilitarFuncao/${2}/${this.idInstituicao}`)
          .then((res) => res.data);
        if (status.length && status[0].status === 1) {
          this.showEditarContainer = true;
        } else {
          this.showEditarContainer = false;
        }
      } catch (error) {
        Swal.fire(
          "Informação",
          "Ocorreu um erro durante a validação da função editar dados!",
          "error"
        );
      }
    },

    async pesquisarStatusSaldo(estudante) {
      try {
        let params = {
          matricula: this.estudante.numero_matricula
        };

        let result = await axios.post("/ObterStatusSaldoAluno", params)
          .then((res) => res.data);
        if (result.saldo) {
          this.saldoEstudante = result.saldo;
        } else {
          this.saldoEstudante = 0;
        }

        this.$emit("saldoEstudante", this.saldoEstudante);
      } catch (error) {
        console.log(error);
      }
    },

    async getTemplateRelatorio() {
      try {
        this.overlay = true;
        this.templateFull = await axios
          .get("/obterRelatorioByDescricao/fdi")
          .then((res) => res.data[0]);

          console.log(this.templateFull, ' o template');
          
      } catch (error) {
        Swal.fire(
          "Informação",
          "Ocorreu um erro durante o carregamento do pdf do relatório!",
          "info"
        );
      } finally {
        this.overlay = false;
      }
    },

    getClasse(classe) {
      switch (classe) {
        case 1:
          return "10ª";
        case 2:
          return "11ª";
        case 3:
          return "12ª";
        case 4:
          return "13ª";
        default:
          return "Inválido";
      }
    },

    async imprimirFichaConfirmacao() {
      try {
        this.overlay = true;
        let infoEstudante = await this.ObterHistoricoAcademico({
          idMatricula: this.estudante.numero_matricula,
        }).then((res) => res.data);
        this.comporHtml(infoEstudante[0]);
      } catch (error) {
        Swal.fire(
          "Informação",
          "Ocorreu um erro durante a impressão do documento!",
          "info"
        );
      } finally {
        this.overlay = false;
      }
    },

    async ObterHistoricoAcademico(params) {
      try {        
        return await axios.post("/ObterInscricaoTurmaEstudante", params);
      } catch (error) {
        Swal.fire(
          "Informação",
          "<p>Ocorreu um erro ao tentar efectuar a operação.</p>",
          "warning"
        );
      }
    },
    descricaoEscola(idCurso) {
     let configuracaoInstituto = ls.get('configuracoesReport').filter(c => c.obs === 'nome_escola')
     return   (idCurso <= 24 ? ls.get('empresa').toUpperCase() : (configuracaoInstituto[1].valor).toUpperCase())
   },
   getlogotipo(idCurso) {
     let logotipoInstituto = ls.get('configuracoesReport').filter(c => c.chave === 'logotipo2')
     return  (idCurso <= 24 ? this.config.logo : (logotipoInstituto[0].valor))
   },

    async comporHtml(estudante) {      
      this.$store.state.loading_pdf = true;

      let template = this.templateFull.documento;
      let dadoss = {
        "{{logoInstituicao}}": this.config.logo,
        "{{nomeInstituicao}}": this.config.nome,
        "{{classe}}": estudante.classe,
        "{{nome}}": estudante.nome,
        "{{dataNascimento}}": this.retornaData(estudante.datanascimento),
        "{{municipio}}": estudante.municipio,
        "{{provincia}}": estudante.provincia,
        "{{bilhete}}": estudante.bi,
        "{{dataEmissao}}": this.retornaData(estudante.dataemissaobi),
        "{{anoLectivo}}": ls.get("anolectivo"),
        "{{turma}}": estudante.turma,
        "{{nomePai}}": estudante.nomedopai,
        "{{nomeMae}}": estudante.nomedamae,
        "{{curso}}": estudante.curso,
        "{{anoLectivoAnterio}}": ls.get("anolectivo") - 1,
        "{{matricula}}": estudante.idMatricula,
        "{{periodo}}": estudante.periodo,
        "{{logotipo}}": this.getlogotipo(estudante.idCurso),
        "{{instituicao}}": this.descricaoEscola(estudante.idCurso),
        "{{dataactual}}": this.retornaData(ls.get("dataActual")),
        "{{autor}}": ls.get('nomeUsuario'),
        "{{anolectivo}}": ls.get("descricaoAnolectivo"),
        "{{datanascimento}}": (estudante.datanascimento)
      };

      const expressaoRegular = new RegExp(Object.keys(dadoss).join("|"), "g");
      template = template.replace(expressaoRegular, (match) => dadoss[match]);

      try {
        let options = {
          format: "A4",
          border: { right: "5mm", left: "5mm" },
          header: { height: "5mm" },
          footer: { height: "5mm" },
        };

        impressaoService.htmlToPdf(template, options);
      } catch (error) {
        Swal.fire(
          "Informação",
          "Ocorreu um erro durante a impressão do documento!",
          "info"
        );
        this.$store.state.loading_pdf = false;
      }
    },

    retornaData(data) {
      let info = data.split("-");
      return info[2] + "-" + info[1] + "-" + info[0];
    },

    editarDados() {
      this.$emit("selectedMenu", 5);
    },
  },
};
</script>
<style scoped>
.card_titulos {
  font-size: 18px;
  padding: 10px;
  text-align: center;
}

ul.list_container_ul {
  text-align: left;
  padding: 0%;
}

.list_items_ul {
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  border-bottom: 1px solid #e2e8f0;
}

.list_items_ul .span_type {
  margin-right: 5px;
}

.flex {
  display: flex;
}

.font-bold {
  font-weight: 700;
}

.text-gray700 {
  color: #4b5563;
}
</style>
